import http from "../axios/http-common";

class InterfaceUtility {
  getDokterByPoli(kdPoli) {
    return http.getData(`/referensi/poli/${kdPoli}/dokter`);
  }
  changeDokterPoli(register, unit_id, dokter_user_id, tgl) {
    return http.putData(`/register/${register}/change-dokter`, {
      unit_id: unit_id,
      dokter_user_id: dokter_user_id,
      tgl: tgl
    });
  }
  getDokterAll() {
    return http.getData(`/combo/dokter`);
  }
  getperawatAll() {
    return http.getData(`/combo/perawat`);
  }
  getKaryawanAll() {
    return http.getData(`/combo/karyawan`);
  }
  getFaskes() {
    return http.getData(`/combo/faskes`);
  }
  getPekerjaan() {
    return http.getData(`/combo/pekerjaan`);
  }

  getUnitRalanPagi() {
    return http.getData(`/combo/unit-ralan-pagi`);
  }

  getUnitRalanByIp(ip) {
    return http.getData(`/unit-ralan-by-ip`);
    // return http.getData(`/ip/${ip}/unit-ralan`);
  }

  getUnitRalan() {
    return http.getData(`/combo/unit-ralan`);
  }

  getPerawatAutoComplete(term) {
    return http.getDataParam(`/referensi/perawat/search`, {
      params: {
        term: term
      }
    })
  }

  getDokterAutoComplete(term) {
    return http.getDataParam(`/referensi/dokter/search`, {
      params: {
        term: term
      }
    })
  }
}

export default new InterfaceUtility();
